import React from 'react'

import { Form, Button } from '_zari/core'

const TIPO_ACTIVO_FIJO = '3'

const FilaDetalleTemplate = ({
  index,
  row,
  actualizarFilaHandler,
  onAbrirSeleccionUbicacion,
  onAbrirRegistroLotes,
  onAbrirRegistroActivosFijos
}) => {
  const [cantidad, setCantidad] = React.useState(row.cantidad)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let __focusSubTotal = false
    let __focusIsc = false
    let __focusFlete = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      __focusSubTotal = true
      saltarCampo = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      __updatedField: 'cantidad',
      __focusCantidad,
      __focusPrecio,
      __focusSubTotal,
      __focusIsc,
      __focusFlete,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad && cantidad === '') {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad, cantidad])

  const tieneUbicacion = !!row._idUbicacion
  const tieneLotes = !!(row.lotes && row.lotes.length > 0)
  const flagLote = !!row.flagLote
  // `tipo` (BIEN/SERVICIO/ACTIVO_FIJO) viene del producto; tipoExistencia es otro
  // campo (clasificación SUNAT) y no coincide con el tipo del producto.
  const esActivoFijo = row.tipo === TIPO_ACTIVO_FIJO
  const tieneUnidades = !!(row.unidades && row.unidades.length > 0)

  const cantTotalLotes = tieneLotes ? row.lotes.reduce((acc, l) => acc + parseFloat(l.cantidad || '0'), 0) : 0
  const cantidadRecibida = parseFloat(cantidad || '0')
  const lotesOk = tieneLotes && cantTotalLotes === cantidadRecibida && cantidadRecibida > 0
  const unidadesAsignadas = tieneUnidades ? row.unidades.filter(u => u._idUbicacion).length : 0
  const unidadesOk = tieneUnidades && unidadesAsignadas === Math.round(cantidadRecibida) && cantidadRecibida > 0

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td className='text-center'>{row.codigoProducto || '--'}</td>
        <td>
          {row.nombreProducto || '--'}
          {esActivoFijo && (
            <span
              className='ml-2'
              style={{
                background: '#DBEAFE',
                color: '#1E40AF',
                border: '1px solid #BFDBFE',
                fontSize: '0.65rem',
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 3,
                textTransform: 'uppercase',
                letterSpacing: '0.04em'
              }}
            >
              Activo Fijo
            </span>
          )}
          {flagLote && !esActivoFijo && (
            <span
              className='ml-2'
              style={{
                background: '#FEF3C7',
                color: '#92400E',
                border: '1px solid #FDE68A',
                fontSize: '0.65rem',
                fontWeight: 700,
                padding: '1px 6px',
                borderRadius: 3,
                textTransform: 'uppercase',
                letterSpacing: '0.04em'
              }}
            >
              Lotes
            </span>
          )}
        </td>
        <td>
          <Form.InputNumber
            ref={inputCantidadRef}
            placeholder='0'
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        <td className='text-center'>{row.nombreUnidadDeMedida || row.unidadMedida || '--'}</td>
        <td>
          {esActivoFijo ? (
            unidadesOk ? (
              <div
                style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
                onClick={() => onAbrirRegistroActivosFijos && onAbrirRegistroActivosFijos(row)}
                title='Click para editar unidades'
              >
                <div style={{ flex: 1, fontSize: '0.75rem', lineHeight: 1.2, color: '#1E40AF' }}>
                  <i className='fa fa-check mr-1' />
                  <strong>{row.unidades.length}</strong> {row.unidades.length === 1 ? 'unidad' : 'unidades'}
                </div>
                <i className='fa fa-pencil-alt' style={{ color: '#1E40AF', fontSize: '0.75rem' }} />
              </div>
            ) : (
              <Button
                size='sm'
                outline
                color='info'
                block
                onClick={() => onAbrirRegistroActivosFijos && onAbrirRegistroActivosFijos(row)}
                disabled={!cantidadRecibida}
              >
                <i className='fa fa-th-large mr-1' />
                Registrar {Math.round(cantidadRecibida) || ''} {Math.round(cantidadRecibida) === 1 ? 'unidad' : 'unidades'}
              </Button>
            )
          ) : flagLote ? (
            lotesOk ? (
              <div
                style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
                onClick={() => onAbrirRegistroLotes && onAbrirRegistroLotes(row)}
                title='Click para editar lotes'
              >
                <div style={{ flex: 1, fontSize: '0.75rem', lineHeight: 1.2, color: '#065F46' }}>
                  <i className='fa fa-check mr-1' />
                  <strong>{row.lotes.length}</strong> {row.lotes.length === 1 ? 'lote' : 'lotes'}
                  <span className='text-muted ml-1'>
                    · {row.lotes.map(l => l.etiquetaUbicacion).filter(Boolean).join(' / ')}
                  </span>
                </div>
                <i className='fa fa-pencil-alt' style={{ color: '#065F46', fontSize: '0.75rem' }} />
              </div>
            ) : (
              <Button
                size='sm'
                outline
                color='warning'
                block
                onClick={() => onAbrirRegistroLotes && onAbrirRegistroLotes(row)}
                disabled={!cantidadRecibida}
              >
                <i className='fa fa-clipboard-list mr-1' />
                Registrar lotes y ubicación
              </Button>
            )
          ) : tieneUbicacion ? (
            <div
              style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
              onClick={() => onAbrirSeleccionUbicacion && onAbrirSeleccionUbicacion(row)}
              title='Click para cambiar ubicación'
            >
              <div style={{ flex: 1, fontSize: '0.78rem', lineHeight: 1.2 }}>
                <div>
                  <strong style={{ color: '#1F3A8A' }}>{row.etiquetaUbicacion}</strong>
                  <span className='text-muted ml-1' style={{ fontSize: '0.7rem' }}>
                    {row.codigoEstanteria}
                  </span>
                </div>
                <div className='text-muted' style={{ fontSize: '0.7rem' }}>
                  {row.nombreAlmacen}
                </div>
              </div>
              <i className='fa fa-pencil-alt' style={{ color: '#1F3A8A', fontSize: '0.78rem' }} />
            </div>
          ) : (
            <Button
              size='sm'
              outline
              color='primary'
              block
              onClick={() => onAbrirSeleccionUbicacion && onAbrirSeleccionUbicacion(row)}
            >
              <i className='fa fa-map-marker-alt mr-1' />
              Asignar
            </Button>
          )}
        </td>
      </tr>
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
